import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import {
  blue as blueStyle,
  green as greenStyle,
  red as redStyle,
  small as smallStyle,
  tag,
} from './styles.module.css';

/**
 * Generic tag presentational component.
 */
const Tag = (props) => {
  const {
    green,
    blue,
    className,
    red,
    small,
    link,
    text,
    ...otherProps
  } = props;

  let finalText = text;
  let colorTheme = '';

  if (blue) {
    colorTheme = blueStyle;
  } else if (red) {
    colorTheme = redStyle;
  } else if (green) {
    colorTheme = greenStyle;
  }

  if (
    text.toLowerCase() === 'official partner' ||
    text.toLowerCase() === 'registration perks'
  ) {
    finalText = 'Registration Perks';
    colorTheme = blueStyle;
  } else if (text.toLowerCase() === 'charity tickets') {
    colorTheme = redStyle;
  }

  return (
    <div
      className={[small ? smallStyle : tag, colorTheme, className]
        .filter(Boolean)
        .join(' ')}
      {...otherProps}
    >
      {link ? <Link to={link}>{finalText}</Link> : finalText}
    </div>
  );
};

Tag.propTypes = {
  /**
   * Boolean to style blue tag.
   */
  blue: PropTypes.bool,
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Boolean to style red tag.
   */
  red: PropTypes.bool,
  /**
   * Boolean to style small tag.
   */
  small: PropTypes.bool,
  /**
   * String text for the tag.
   */
  text: PropTypes.string.isRequired,
  /**
   * String link for the tag.
   */
  link: PropTypes.string,
};

Tag.defaultProps = {
  blue: false,
  className: '',
  red: false,
  small: false,
  link: undefined,
};

export default Tag;
